import { useState } from "react";

const ProfileAvatar = ({ imageUrl, size = 100, className = "", onClick }) => {
    const [imgError, setImgError] = useState(false);

    const sizeStyle = {
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`,
        borderRadius: "50%",
        cursor: onClick ? "pointer" : "default",
    };

    // 클릭 가능한 아바타는 키보드로도 열 수 있어야 한다
    const interactiveProps = onClick
        ? {
              role: "button",
              tabIndex: 0,
              onClick,
              onKeyDown: (e) => {
                  if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      onClick(e);
                  }
              },
          }
        : {};

    if (imageUrl && !imgError) {
        return (
            <img
                className={`profile-avatar-img ${className}`}
                src={imageUrl}
                alt="프로필 이미지"
                style={{ ...sizeStyle, objectFit: "cover" }}
                onError={() => setImgError(true)}
                {...interactiveProps}
            />
        );
    }

    return (
        <div
            className={`icon-user ${className}`}
            style={{ ...sizeStyle, backgroundColor: "#eee" }}
            aria-label={onClick ? "프로필 이미지" : undefined}
            {...interactiveProps}
        />
    );
};

export default ProfileAvatar;
